module.exports = __webpack_public_path__ + "img/shusong1.61f86de0.png";